import { FunctionComponent } from 'react';

export type SeparatorMoonProps = {
  width: number;
  height: number;
  fill: string;
};

type FC = FunctionComponent<SeparatorMoonProps>;

const SeparatorMoon: FC = (props: SeparatorMoonProps) => {
  const { width, height, fill } = props;

  return (
    <svg width={`${width}%`} height={`${height}%`} viewBox="0 0 556 924" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M519.5 -125L495.5 -25C471.5 75 423.5 275 429.5 475C435.5 675 495.5 875 525.5 975L555.5 1075L-120 1075L-120 975C-120 875 -120 675 -120 475C-120 275 -120 75 -120 -25L-120 -125L519.5 -125Z"
        fill={fill}
      />
    </svg>
  );
};

export default SeparatorMoon;
